import { TOTAL_SCREENS } from "../data/screenConfig";

function JourneyFooter({ currentScreen, onBack, onNext }) {
  const isFirstScreen = currentScreen === 1;
  const isLastScreen = currentScreen === TOTAL_SCREENS;

  return (
    <footer className="journey-footer" aria-label="Patient feedback navigation">
      <label className="journey-button journey-button--back">
        <input
          className="journey-button__control"
          type="button"
          name="ui_action"
          value="back"
          aria-label="Back"
          disabled={isFirstScreen}
          onClick={onBack}
        />
        <span className="journey-button__arrow" aria-hidden="true">
          {"\u2190"}
        </span>
        <span className="journey-button__text" aria-hidden="true">
          Back
        </span>
      </label>

      <div
        className="journey-progress"
        aria-label={`Screen ${currentScreen} of ${TOTAL_SCREENS}`}
      >
        <span>
          {currentScreen} of {TOTAL_SCREENS}
        </span>
        <div className="journey-progress__dots" aria-hidden="true">
          {screenDots(currentScreen)}
        </div>
      </div>

      <label className="journey-button journey-button--next">
        <input
          className="journey-button__control"
          type="button"
          name="ui_action"
          value={isLastScreen ? "submit" : "next"}
          aria-label={isLastScreen ? "Submit \u2192" : "Next \u2192"}
          onClick={onNext}
        />
        <span className="journey-button__text" aria-hidden="true">
          {isLastScreen ? "Submit Now" : "Next"}
        </span>
        <span className="journey-button__arrow" aria-hidden="true">
          {"\u2192"}
        </span>
      </label>
    </footer>
  );
}

function screenDots(currentScreen) {
  return Array.from({ length: TOTAL_SCREENS }, (_, index) => {
    const screenNumber = index + 1;
    const state =
      screenNumber === currentScreen
        ? " is-active"
        : screenNumber < currentScreen
          ? " is-complete"
          : "";
    return <i className={`journey-dot${state}`} key={screenNumber} />;
  });
}

export default JourneyFooter;
